<script>
  import { _ } from 'svelte-i18n'

  import MarkdownBlock from '/components/Atoms/MarkdownBlock'

  export let data

  let body = data?.body
  .filter( e => e.__typename === "body_textBlock_BlockType")
  .map( e => e.textBlock)
  .join("\n")

</script>

<section class="almanac-item">
  <div class="content">
    <MarkdownBlock source={body} almanac={false} />
  </div>
</section>

<style lang="scss">
  section {

    .content {
      max-width: 740px;
      box-sizing: border-box;

      margin-left: 20px;
      margin-right: 20px;

      @include media-1col-only {
        margin-left: 20px;
        margin-right: 20px;
      }

      margin-top: 20px;
    }
  }

  h1 {
    @include typo-serif-small-caps-28;
    color: $color-red;
    margin-bottom: 32px;
  }

  .content {
    @include typo-serif-text-28;
  }

</style>